module.exports = __webpack_public_path__ + "static/media/icons-global-contact-email-gray.07ef8bb6.svg";